import React, { Component } from "react";
// import { FormGroup, Label, Col } from "reactstrap";
// import Select from 'react-select';
import { axiosInstance2 } from "../../../../utils/axiosConfig";
import CommonConfig from "../../../commonConfig.json";

import { Row, Col, Select, Form } from "antd";
import "antd/dist/antd.css";

const { Option } = Select;

const REACT_APP_HMG = process.env["REACT_APP_HMG"];
const ENVS = CommonConfig.envs;

class HotelDropDown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: { hotelList: [] },
    };
  }

  componentDidMount() {
    this.loadHotels(this.props.projectDetails);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.projectDetails != this.props.projectDetails) {
      // alert(JSON.stringify(newProps.projectDetails) + " ||| "+ JSON.stringify(this.props.projectDetails))
      this.loadHotels(newProps.projectDetails);
    }
  }

  loadHotels(projectDetails) {
    let userName = this.props.user["https://myapp.com/UserName"];
    let pms = sessionStorage.getItem("pms");
    axiosInstance2
      .post("/api/userHotels/getUserHotelList", {
        userId: userName,
        pms: (pms === "null")?null:pms,
        projectDetails: projectDetails,
      })
      .then((response) => {
        if (response["data"]["error"]) {
          return;
        }
        this.setState({ data: response["data"] });
      }); //.catch((error) => {alert(error["message"])} );
  }

  render() {
    const data = this.state.data;
    const postsDet = [];

    for (let x = 0; x < data["hotelList"].length; x++) {
      let group = data["hotelList"][x];
      for (let y = 0; y < group["hotelList"].length; y++) {
        postsDet.push({
          value: group["hotelList"][y]["hotel_id"],
          code: group["hotelList"][y]["hotel_code"],
          name: group["hotelList"][y]["hotel_name"],
          label:
            group["hotelList"][y]["hotel_code"] +
            " - " +
            group["hotelList"][y]["hotel_name"],
        });
      }
    }

    postsDet.sort(function (a, b) {
      if (REACT_APP_HMG === ENVS.GENERIC) {
        return a.name.toUpperCase() > b.name.toUpperCase() ? 1 : -1;
      } else {
        return a.code.toUpperCase() > b.code.toUpperCase() ? 1 : -1;
      }
    });

    let drpdwnoptions = postsDet.map((item, i) => {
      return (
        <Option
          key={item.value}
          value={JSON.stringify({
            value: item.value,
            code: item.code,
            name: item.name,
          })}
        >
          {item.label}
        </Option>
      );
    }, this);
    //alert(this.props.hotelVal)
    console.log(postsDet, "postsDet");
    if (drpdwnoptions.length > 0) {
      return (
        // </FormGroup>
        <Row type="flex" justify="center">
          <Col span={6}>
            <span style={{ paddingRight: "10px" }}>
              {this.props.hotelIndexName}
            </span>
          </Col>
          <Col span={18}>
            <Form.Item name={this.props.hotelIndexName}>
              <Select
                allowClear
                labelInValue
                showSearch
                style={{ width: "100%" }}
                placeholder={this.props.hotelIndexName}
                optionFilterProp="children"
                onChange={(selectedOption) => {
                  // alert(selectedOption)
                  let sel = null;
                  if (selectedOption !== undefined) {
                    sel = JSON.parse(selectedOption.key);
                    sel["label"] = selectedOption.label;
                  }

                  this.props.processFilter(
                    this.props.hotelIndexName,
                    sel,
                    this.props.searchIn,
                    this.props.valuesType,
                    selectedOption,
                    this.props.additionalData
                  );
                }}
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
              >
                {drpdwnoptions}
              </Select>
            </Form.Item>
          </Col>
        </Row>
      );
    } else {
      return (
        <Row type="flex" justify="center">
          <Col span={6}>
            <span style={{ paddingRight: "10px" }}>Hotel Name</span>
          </Col>
          <Col span={18}>
            <Select
              allowClear
              labelInValue
              showSearch
              style={{ width: "100%" }}
              placeholder="Select a hotel name"
            ></Select>
          </Col>
        </Row>
      );
    }
  }
}

export default HotelDropDown;
